<template>
  <ul class="client-ul" v-loading="fullLoading">
    <li class="hm-search">
      <!-- 查询部分 -->
      <el-form :inline="true" :model="searchForm">
        <el-form-item :label="$t('Components.Database.Client.Search')">
          <el-input
            v-model="searchForm.inputSearch"
            :placeholder="$t('Components.Database.Client.Name')"
            clearable
          />
        </el-form-item>
        <el-form-item :label="$t('Components.Database.Client.Category')">
          <el-select v-model="searchForm.category" :placeholder="t('Components.Database.Client.PleaseSelectCategory')" clearable> 
          <el-option
            v-for="item in dicItemsFilter(clientCategorys)"
            :key="item.guid"
            :label="item.name"
            :value="item.value"
          />
        </el-select>
        </el-form-item>
        <el-form-item :label="$t('Components.Database.Client.Dataflag')">
          <el-select
            v-model="searchForm.dataflag"
            :placeholder="$t('Components.Database.Client.SelectDataflag')"
            clearable
          >
            <el-option
              :label="$t('Components.Database.Client.DataflagY')"
              value="true"
            />
            <el-option
              :label="$t('Components.Database.Client.DataflagN')"
              value="false"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="buttonVisible.searchButton"
            type="primary"
            @click="queryClick"
            :icon="Search"
            >{{ $t("Components.Database.Client.Search1") }}</el-button
          >
          <el-button
            v-if="buttonVisible.resetButton"
            @click="resetClick"
            :icon="RefreshLeft"
            >{{ $t("Components.Database.Client.Reset") }}</el-button
          >
        </el-form-item>
      </el-form>
    </li>
    <li class="hm-operate">
      <!-- 操作部分 -->
      <el-button
        v-if="buttonVisible.addButton"
        :style="{ color: 'white' }"
        :icon="Plus"
        :color="ButtonColor.Add"
        @click="
          () => {
            dialogVisible = true;
          }
        "
        >{{ $t("Components.Database.Client.Add") }}</el-button
      >
      <el-button
        v-if="buttonVisible.editButton"
        :disabled="!(selectClients && selectClients.length === 1)"
        :style="{ color: 'white' }"
        :icon="Edit"
        :color="ButtonColor.Edit"
        @click="handleEdit(1)"
        >{{ $t("Components.Database.Client.Edit") }}</el-button
      >
      <el-button
        v-if="buttonVisible.deleteButton"
        :disabled="!(selectClients && selectClients.length > 0)"
        :style="{ color: 'white' }"
        :icon="Delete"
        :color="ButtonColor.Delete"
        @click="handleDeleteBatch"
        >{{ $t("Components.Database.Client.Delete") }}</el-button
      >
      <el-button
        v-if="buttonVisible.exportButton"
        :style="{ color: 'white' }"
        :icon="Download"
        :color="ButtonColor.Export"
        @click="handleExport"
        >{{ $t("Components.Database.Client.Export") }}</el-button
      >
    </li>
    <el-scrollbar>
      <li class="hm-table">
        <!-- 表格部分 -->
        <el-table
          v-loading="tableLoading"
          :data="tableData"
          row-key="guid"
          @sort-change="handleSortChange"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" />
          <el-table-column
            prop="name"
            :label="$t('Components.Database.Client.Name')"
          />
          <el-table-column
            prop="category"
            :label="$t('Components.Database.Client.Category')"
          >
            <template #default="scope">
              {{ computeClientCategory(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="sort"
            :label="$t('Components.Database.Client.Sort')"
          />
          <el-table-column
            prop="dataflag"
            :label="$t('Components.Database.Client.Dataflag')"
          >
            <template #default="scope">
              <el-switch
                :disabled="!buttonVisible.dataflag || scope.row.is_system"
                v-model="scope.row.dataflag"
                @change="(flag) => handleDataflagChange(flag, scope.row)"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="createtime"
            sortable
            :label="$t('Components.Database.Client.CreateTime')"
          />
          <el-table-column
            :label="$t('Components.Database.Client.Operate')"
            width="200"
          >
            <template #default="scope">
              <el-space wrap v-if="!scope.row.is_system">
                <el-button
                  v-if="buttonVisible.editButtonLine"
                  :style="{ color: 'white' }"
                  :icon="Edit"
                  :color="ButtonColor.Edit"
                  size="small"
                  @click="handleEdit(2, scope.row)"
                  >{{ $t("Components.Database.Client.Edit") }}</el-button
                >
                <el-button
                  v-if="buttonVisible.deleteButtonLine"
                  :style="{ color: 'white' }"
                  :icon="Delete"
                  :color="ButtonColor.Delete"
                  size="small"
                  bg
                  @click="handleDelete(scope.row)"
                  >{{ $t("Components.Database.Client.Delete") }}</el-button
                >
              </el-space>
            </template>
          </el-table-column>
        </el-table>
      </li>
    </el-scrollbar>

    <li class="hm-page">
      <el-pagination
      small
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :page-sizes="AllPageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </li>
  </ul>
  <ClientModify
    v-if="dialogVisible"
    @handleCloseDialog="handleCloseDialog"
    :editData="editData"
    @getClientPage="getClientPage"
    :clientCategorys="clientCategorys"
  />
</template>
<script setup>
import { reactive, ref, markRaw, onMounted, watchEffect, computed } from "vue";
import {
  Plus,
  Delete,
  RefreshLeft,
  Edit,
  Search,
  WarnTriangleFilled,
  Download,
} from "@element-plus/icons-vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { useI18n } from "vue-i18n";
import {
  AllPageSize,
  ButtonColor,
  DefaultPageSize,
} from "@/consts/frame";
import {
  request_client_page,
  request_client_delete,
  request_client_delete_batch,
  request_client_dataflag,
  request_client_export,
} from "@/api/apis";
import ClientModify from "@/components/Database/Client/ClientModify";
import { MenuCodes, MenuButtonCodes } from "@/consts/menuAndMenuButtonCode";
import { validateMenuButton, dicItemsFilter } from "@/util/util";
import { useStore } from "@/store/index";
import { Dics } from "@/consts/dic";

const store = useStore();
const { t } = useI18n();
const searchForm = reactive({
  inputSearch: "",
  dataflag: undefined,
  category: ''
});
const buttonVisible = reactive({
  searchButton: false,
  resetButton: false,
  addButton: false,
  editButton: false,
  deleteButton: false,
  editButtonLine: false,
  deleteButtonLine: false,
  dataflag: false,
  exportButton: false,
});
// 当前页码
const currentPage = ref(1);
// 页码大小
const pageSize = ref(DefaultPageSize);
// 表格数据
const tableData = ref([]);
// 表格加载
const tableLoading = ref(false);
// 总数量
const total = ref(0);
// 编辑的数据
const editData = ref({});
// 弹窗是否可见
const dialogVisible = ref(false);
// 创建时间排序规则 如果为undefined 则没有这个参数，如果为true代表倒叙，为false代表正序
const createTimeSort = ref(undefined);
// 排序排序规则 如果为undefined 则没有这个参数，如果为true代表倒叙，为false代表正序
const sortSort = ref(undefined);
// 选择的委托方
const selectClients = ref([]);
// 全屏加载
const fullLoading = ref(false);
// 委托方分类
const clientCategorys = ref([]);

// 处理分类成字典数据
const computeClientCategory = computed(() => (data) => {
  if (clientCategorys.value) {
    const findAnnnouncementType = clientCategorys.value.find(
      (item) => item.value == data.category
    );
    if (findAnnnouncementType) {
      return findAnnnouncementType.name;
    }
  }
});
onMounted(async () => {
  await getClientPage();
});
// 分页查询委托方
const getClientPage = async () => {
  const trans = {
    pagesize: pageSize.value,
    pageindex: currentPage.value,
    text: searchForm.inputSearch,
    dataflag: searchForm.dataflag,
    category: searchForm.category,
    createTimeSort: createTimeSort.value,
    sort: sortSort.value,
  };
  tableLoading.value = true;
  const result = await request_client_page(
    trans,
    () => (tableLoading.value = false)
  );
  total.value = result.total;
  tableData.value = result.rows;
  selectClients.value = [];
  editData.value = {};
};

// 查询事件
const queryClick = () => {
  getClientPage();
};
// 重置事件
const resetClick = () => {
  searchForm.dataflag = undefined;
  searchForm.inputSearch = "";
  searchForm.category = ''
  getClientPage();
};
// 处理页码大小改变事件
const handleSizeChange = (size) => {
  pageSize.value = size;
  getClientPage();
};
// 处理当前页改变事件
const handleCurrentChange = (index) => {
  currentPage.value = index;
  getClientPage();
};
// 处理编辑事件
const handleEdit = (type, data) => {
  let row = undefined;
  if (type === 1) {
    // 判断是否有且仅选择了一条用户数据
    if (selectClients.value.length !== 1) {
      ElMessage.warning(t("Components.Database.Client.OnlyOneSelectEdit"));
      return;
    }
    row = selectClients.value[0];
  } else if (type === 2) {
    row = data;
  }
  editData.value = {
    guid: row.guid,
    name: row.name,
    abbreviation: row.abbreviation,
    category: row.category,
    sort: row.sort
  };
  dialogVisible.value = true;
};
// 处理回调关闭事件
const handleCloseDialog = () => {
  dialogVisible.value = false;
  editData.value = {};
};
// 处理有效性改变事件
const handleDataflagChange = async (flag, row) => {
  await request_client_dataflag(row.guid, true, () => {
    row.dataflag = !row.dataflag;
  });
};
// 处理选择回调事件
const handleSelectionChange = (clients) => {
  selectClients.value = clients;
};
// 处理删除
const handleDelete = async (row) => {
  ElMessageBox.confirm(
    t("Components.Database.Client.ConfirmDeleteClient"),
    t("Common.ElMessageBox.OperateConfirm"),
    {
      confirmButtonText: t("Common.ElMessageBox.ConfirmText"),
      cancelButtonText: t("Common.ElMessageBox.CancelText"),
      type: "warning",
      icon: markRaw(WarnTriangleFilled),
    }
  )
    .then(async () => {
      await request_client_delete(row.guid, true);
      getClientPage();
    })
    .catch(() => {});
};
// 批量删除
const handleDeleteBatch = async () => {
  if (selectClients.value.length === 0) {
    ElMessage.warning(t("Components.Database.Client.AtLeastOneClient"));
    return;
  }
  ElMessageBox.confirm(
    t("Components.Database.Client.ConfirmDeleteClient"),
    t("Common.ElMessageBox.OperateConfirm"),
    {
      confirmButtonText: t("Common.ElMessageBox.ConfirmText"),
      cancelButtonText: t("Common.ElMessageBox.CancelText"),
      type: "warning",
      icon: markRaw(WarnTriangleFilled),
    }
  )
    .then(async () => {
      const trans = {
        guids: selectClients.value.map((item) => item.guid),
      };
      await request_client_delete_batch(trans, true);
      getClientPage();
    })
    .catch(() => {});
};
// 处理排序改变事件
const handleSortChange = async ({ prop, order }) => {
  if (prop === "createtime") {
    sortSort.value = undefined;
    // 创建时间排序
    if (order === "ascending") {
      // 时间正序
      createTimeSort.value = false;
    } else if (order === "descending") {
      // 时间倒叙
      createTimeSort.value = true;
    } else {
      createTimeSort.value = undefined;
    }
  } else if (prop === "sort") {
    createTimeSort.value = undefined;
    // 序号排序
    if (order === "ascending") {
      // 序号正序
      sortSort.value = false;
    } else if (order === "descending") {
      // 序号倒叙
      sortSort.value = true;
    } else {
      sortSort.value = undefined;
    }
  }
  await getClientPage();
};
// 导出
const handleExport = async () => {
  fullLoading.value = true;
  const trans = {
    pagesize: pageSize.value,
    pageindex: currentPage.value,
    text: searchForm.inputSearch,
    dataflag: searchForm.dataflag,
    createTimeSort: createTimeSort.value,
    sort: sortSort.value,
  };
  const result = await request_client_export(
    trans,
    true,
    () => (fullLoading.value = false)
  );
  const link = document.createElement("a");
  link.style.display = "none";
  link.href = result;
  link.target = '_blank'
  document.body.appendChild(link);
  link.click();
};
watchEffect(() => {
  if (store.userMenus) {
    // 处理查询
    buttonVisible.searchButton = validateMenuButton(
      store.userMenus,
      MenuCodes.Database.Client,
      MenuButtonCodes.Database.Client.ClientSearch
    );
    // 处理重置
    buttonVisible.resetButton = validateMenuButton(
      store.userMenus,
      MenuCodes.Database.Client,
      MenuButtonCodes.Database.Client.ClientReset
    );
    // 处理新增
    buttonVisible.addButton = validateMenuButton(
      store.userMenus,
      MenuCodes.Database.Client,
      MenuButtonCodes.Database.Client.ClientAdd
    );
    // 处理编辑
    buttonVisible.editButton = validateMenuButton(
      store.userMenus,
      MenuCodes.Database.Client,
      MenuButtonCodes.Database.Client.ClientEdit
    );
    // 处理删除
    buttonVisible.deleteButton = validateMenuButton(
      store.userMenus,
      MenuCodes.Database.Client,
      MenuButtonCodes.Database.Client.ClientDelete
    );
    // 处理删除行
    buttonVisible.editButtonLine = validateMenuButton(
      store.userMenus,
      MenuCodes.Database.Client,
      MenuButtonCodes.Database.Client.ClientEditLine
    );
    // 处理删除行
    buttonVisible.deleteButtonLine = validateMenuButton(
      store.userMenus,
      MenuCodes.Database.Client,
      MenuButtonCodes.Database.Client.ClientDeleteLine
    );
    // 处理有效性
    buttonVisible.dataflag = validateMenuButton(
      store.userMenus,
      MenuCodes.Database.Client,
      MenuButtonCodes.Database.Client.ClientDataflag
    );
    // 处理导出
    buttonVisible.exportButton = validateMenuButton(
      store.userMenus,
      MenuCodes.Database.Client,
      MenuButtonCodes.Database.Client.ClientExport
    );
  }
});


watchEffect(() => {
  if (store.userInfo) {
    if (store.userInfo.dics && store.userInfo.dics.length > 0) {
      const findClientCategoryDic = store.userInfo.dics.find(
        (item) => item.code === Dics.System.ClientCategory
      );
      if (findClientCategoryDic) {
        if (
          findClientCategoryDic.items &&
          findClientCategoryDic.items.length > 0
        ) {
          clientCategorys.value = findClientCategoryDic.items;
        } else {
          clientCategorys.value = [];
        }
      } else {
        clientCategorys.value = [];
      }
    } else {
      clientCategorys.value = [];
    }
  }
});
</script>
<style>
.client-ul .el-scrollbar__view {
  height: calc(100% - 8px);
}
</style>
<style scoped lang="scss">
.client-ul {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
